export const CATALOG_SEARCH_LOCAL_STORAGE_KEY = 'catalog-search';
export const CATALOG_CASTOR_CONFIG_LOCAL_STORAGE_KEY = 'catalog-castor-config';
export const CATALOG_DETAIL_LOCAL_STORAGE_KEY = 'catalog-detail';
export const CATALOG_FACET_LOCAL_STORAGE_KEY = 'catalog-facet';
